import { axios } from "../../lib/axios";
import { ApiError } from "../../types/ApiError";
export type ConsultantsDTO = {
    id:string;
    name:string;
    consultantDates:Dates[]
    img_url:string;
    title:string;
    createdAt:string;
    updatedAt:string;
};
export interface Dates {
  id: string;
  time: string;
  day: string;
  isAvailable: boolean;
  consultantId: string;
  createdAt: string;
  updatedAt: string;

}
type getConsultantsResponse = {
  statusCode?: number;
  error?: null | ApiError;
  data?: ConsultantsDTO;
};
export const GetConsultantById = async (id: string): Promise<getConsultantsResponse> => {
  try {
    const response = await axios.get(`/consultant/${id}`);
    return { data: response.data };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
